__turbopack_context__.v({
  "amount_text": "DetailTotalAmount-module-scss-module__Vo9tSW__amount_text",
  "blue": "DetailTotalAmount-module-scss-module__Vo9tSW__blue",
  "default": "DetailTotalAmount-module-scss-module__Vo9tSW__default",
  "icon": "DetailTotalAmount-module-scss-module__Vo9tSW__icon",
  "inner_wrap": "DetailTotalAmount-module-scss-module__Vo9tSW__inner_wrap",
  "red": "DetailTotalAmount-module-scss-module__Vo9tSW__red",
  "title": "DetailTotalAmount-module-scss-module__Vo9tSW__title",
  "wrap": "DetailTotalAmount-module-scss-module__Vo9tSW__wrap",
});
